const BaseRandomizer = require('./base');
const { shuffle } = require('../math/seed-rng');
const { validateClusterStrata } = require('../math/validation');

class ClusterStratifiedRandomization extends BaseRandomizer {
  constructor() {
    super('cluster-stratified', 'Cluster-Stratified Randomization');
  }

  validateParams(params) {
    const parsed = validateClusterStrata(params.clusterStrataSizes, params.n, params.arms);
    params.clusterStrataPlan = parsed.strata;
    params.clusterStrataClusters = parsed.clusters;
    params.methodWarnings = parsed.warnings;
  }

  selectResultParameters(params) {
    return {
      ...super.selectResultParameters(params),
      clusterStrataSizes: params.clusterStrataSizes,
      clusterStrata: params.clusterStrataPlan,
      clusters: params.clusterStrataClusters,
      randomizationUnit: 'cluster',
      balanceUnit: 'cluster-stratum',
      methodWarnings: params.methodWarnings
    };
  }

  randomize(rng, params) {
    const sequence = [];
    let patientIndex = 0;

    params.clusterStrataPlan.forEach((stratum) => {
      const balancedArms = stratum.clusters.map((_, index) => index % params.arms);
      const shuffledArms = shuffle(balancedArms, rng);

      stratum.clusters.forEach((cluster, clusterIndex) => {
        const armIndex = shuffledArms[clusterIndex];

        for (let i = 0; i < cluster.size; i += 1) {
          sequence.push(this.buildAssignment(patientIndex, armIndex, {
            cluster: cluster.id,
            stratum: stratum.id
          }));
          patientIndex += 1;
        }
      });
    });

    return sequence;
  }

  getExplanation() {
    return `
      <h3>Cluster-Stratified Randomization</h3>
      <p>Clusters are grouped into strata, then whole clusters are randomized within each stratum.</p>
      <pre>For each stratum:
  list clusters in that stratum
  assign one seeded arm to each cluster
  apply that arm to every participant in the cluster</pre>
      <p>The cluster remains the unit of randomization; participants inside a cluster do not receive different arms.</p>
    `;
  }
}

module.exports = ClusterStratifiedRandomization;
